import { Checkbox } from "@atlas-design-system/react";
import { actionButtons } from "./actionButtons";

export const fdEntryColumns = [
    {
        enableSorting: false,
        enableColumnFilter: false,
        accessorKey: 'select',
        header: ({ table }) => (
            <Checkbox
                label=''
                {...{
                    checked: table.getIsAllRowsSelected(),
                    indeterminate: table.getIsSomeRowsSelected(),
                    onChange: table.getToggleAllRowsSelectedHandler()
                }}
            />
        ),
        cell: ({ row }) => (
            <Checkbox
                label=''
                {...{
                    checked: row.getIsSelected(),
                    indeterminate: row.getIsSomeSelected(),
                    onChange: row.getToggleSelectedHandler()
                }}
            />
        )
    },
    {
        header: () => 'Airline code',
        accessorKey: 'airlineCode',
        editable: true,
        required: true,
        regEx: new RegExp('^\\w{2}$', 'm'),
        regExMessage: 'Airline code must be 2 alphanumeric'
    },
    {
        header: () => 'FD entry',
        accessorKey: 'fdEntry',
        editable: true,
        required: true,
        regEx: new RegExp('^FD\\w{6}\\/\\w{2}.*', 'm'),
        regExMessage: 'FD entry format must be FDXXXYYY/ZZ'
    },
    {
        header: () => 'Deal code',
        accessorKey: 'dealCode',
        editable: true,
        required: false,
    },
    {
        enableColumnFilter: false,
        header: () => 'Timestamp',
        accessorKey: 'timestamp',
        sortDescFirst: true,
        cell: (info) => new Date(info.getValue()).toLocaleString(),
        sortingFn: (rowA, rowB, columnId) =>
            {
                var dateA = new Date(rowA.original[columnId]);
                var dateB = new Date(rowB.original[columnId]);
                if(dateA < dateB) return -1;
                if(dateA > dateB) return 1;
                return 0;
            }
    },
    {
        enableSorting: false,
        enableColumnFilter: false,
        header: () => 'Actions',
        accessorKey: 'actions',
        meta: {
            align: 'right'
        },
        cell: (info) => actionButtons(info)
    }
];

